import { Col, Row } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';

import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';

import identifikaceEmitenta, { IIdentifikaceEmitenta } from 'services/akcionar/emise/identifikaceEmitenta';
import { IRozcestnikData } from 'services/akcionar/emise/rozcestnikISIN';
import { vyjadreniCdcpIsinApi } from 'services/spravaEmitenta/vyjadreniCdcp';

import { EEvidenceCp } from 'enums/isin/evidenceCp';
import { ERozcestnikOptions } from 'enums/isin/rozcestnikOptions';
import { EDruhCp } from 'enums/isin/udaje/druhCp';

import IdentifikaceEmitentaNovy, { IRozcestnikInput } from '../novyISIN/IdentifikaceEmitentaNovy';
import Rozcestnik from '../novyISIN/RozcestnikNovy';
import ZadostPosila from '../novyISIN/ZadostPosila';
import RegistraceDruhCp from './RegistraceDruhCp';

interface INovyISIN {}

const NovyISIN: React.FC<INovyISIN> = () => {
    const { isin, cisStaty } = useContext(Context);
    const prevStepRef = useRef(0);
    const [currentStep, setCurrentStep] = useState<number>(0);
    const [identifikacePutData, setIdentifikacePutData] = useState<IIdentifikaceEmitenta | undefined>();
    const [zadostID, setZadostID] = useState<number | undefined>(isin ? isin.idZadosti : 0);
    const [rozcestnikData, setRozcestnikData] = useState<IRozcestnikData['spolecnost']>();
    const [modalMessage, setModalMessage] = useState<string>('');
    const [rozcestnikInput, setRozcestnikInput] = useState<IRozcestnikInput | undefined>(
        isin
            ? {
                  emitentje: isin.emitentje || '',
                  ...(isin.emitentje && {
                      evidencecp: isin.evidencecp as EEvidenceCp
                  }),
                  podobacp: isin.podobacp || ''
              }
            : undefined
    );
    const [loading, setLoading] = useState<boolean>(false);
    const [druhCP, setDruhCP] = useState<EDruhCp | undefined>();

    const next = () => {
        setCurrentStep(currentStep + 1);
    };

    const prev = () => {
        prevStepRef.current = currentStep;
        setCurrentStep(currentStep - 1);
    };

    useEffect(() => {
        if (isin && isin.stav === 'kdoplneni') {
            // zobrazi vyjadrenie cdcp v modale
            setLoading(true);
            vyjadreniCdcpIsinApi(isin.idZadosti ? isin.idZadosti : 0)
                .then(data => setModalMessage(data.vyjadreni))
                .finally(() => {
                    isin && setCurrentStep(1);
                    setLoading(false);
                });
        } else {
            isin && setCurrentStep(1); // ak je isin = rozpracovana ziadost => prejde na dalsiu stranu
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        identifikacePutData &&
            zadostID &&
            identifikaceEmitenta('PUT', zadostID, identifikacePutData, 'Registration').then(() => {
                setLoading(false);
                currentStep === 1 && next();
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [identifikacePutData, zadostID]);

    const steps = [
        {
            title: '',
            content: (
                <Rozcestnik
                    cisStaty={cisStaty}
                    rozcestnikData={rozcestnikData}
                    setRozcestnikData={setRozcestnikData}
                    setRozcestnikInput={setRozcestnikInput}
                    setDruhCP={setDruhCP}
                    nextStep={next}
                    setZadostID={setZadostID}
                    zadostID={zadostID}
                    identifikacePutData={identifikacePutData}
                    rozcestnikInput={rozcestnikInput}
                    setIdentifikacePutData={setIdentifikacePutData}
                    isRegistration={true}
                />
            )
        },
        {
            title: 'ISIN_IDENTIFIKACE_IDENTIFIKACE_EMITENTA',
            content: (
                <IdentifikaceEmitentaNovy
                    zadostID={zadostID}
                    // rozpracovanaZadost={!!isin}
                    modalMessage={modalMessage}
                    setModalMessage={setModalMessage}
                    rozcestnikData={rozcestnikData}
                    rozcestnikInput={rozcestnikInput}
                    prevStep={prev}
                    identifikacePutData={identifikacePutData}
                    setIdentifikacePutData={setIdentifikacePutData}
                    isRegistration={true}
                />
            )
        },
        {
            title: '',
            content: (
                <RegistraceDruhCp
                    prevStep={prev}
                    nextStep={next}
                    zadostID={zadostID!}
                    setIdentifikacePutData={setIdentifikacePutData}
                />
            )
        },
        {
            title: '',
            content: (
                <ZadostPosila
                    prevStep={prev}
                    zadostID={zadostID}
                    druhCP={druhCP}
                    mode={ERozcestnikOptions.REGISTRATION}
                    identifikacePutData={identifikacePutData}
                />
            )
        }
    ];

    return (
        <LoadingWrapper loading={loading}>
            <Title level={3} text="FORMULARE_ZADOST_REGI" />
            <Title level={4} text={steps[currentStep].title} />
            <Row gutter={8}>
                <Col span={24}>{steps[currentStep].content}</Col>
            </Row>
        </LoadingWrapper>
    );
};

export default NovyISIN;
